import { Injectable } from '@angular/core';
import { SynchronizationService } from '../../../services/synchronization.service';
import { MpcBoardSprint } from './mpc-board-sprint.component';
import { ActionViewSynchroHelper } from '../../../actionviews/actionview-synchro-helper';

/**
 * This class is encapsulating the handling of synchronsation-events for the MPC-Sprint-Board-Component
 */
@Injectable()
export class MPCSprintBoardSyncroHelper {
  constructor(
    private syncService: SynchronizationService,
    private actionViewSync: ActionViewSynchroHelper) {
  }

  public initSyncEventListeners(sprintBoard: MpcBoardSprint) {
    // Init events shared by all boards
    // TODO check if this works/makes sense for sprintboard
    // this.actionViewSync.initSyncEventListeners(taskboard);
  }

  // TODO implement SYNC events for MPC



}
